<a
  (click)="onClick()"
  [title]="title()"
  [attr.aria-disabled]="disabled() || null"
  [class]="disabled()
    ? 'inline-flex items-center w-full p-2 rounded min-w-0 text-fg-disabled cursor-not-allowed'
    : 'inline-flex items-center w-full p-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded cursor-pointer min-w-0'"
>
    <ng-content></ng-content>
</a>
